import { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import styles from './Features2.module.css';
import sideImg from '../../Images/image.png';

// Register ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);

export default function Features2() {
  const sectionRef = useRef(null);
  const leftContentRef = useRef(null);
  const featureImageRef = useRef(null);
  const featureItemsRef = useRef([]);

  // useEffect(() => {
  //   // Create a GSAP context to scope animations to this component
  //   const ctx = gsap.context(() => {
  //     // Animate Left Content (title and subtitle)
  //     const title = leftContentRef.current?.querySelector(`.${styles.title}`);
  //     const subtitle = leftContentRef.current?.querySelector(`.${styles.subtitle}`);
  //     if (title && subtitle) {
  //       gsap.fromTo(
  //         [title, subtitle],
  //         { y: 50, opacity: 0 },
  //         {
  //           y: 0,
  //           opacity: 1,
  //           duration: 0.8,
  //           stagger: 0.2,
  //           ease: 'power3.out',
  //           scrollTrigger: {
  //             trigger: sectionRef.current,
  //             start: 'top 85%',
  //             end: 'top 60%',
  //             scrub: 0.5,
  //             markers: false,
  //           },
  //         }
  //       );
  //     }

  //     // Animate Feature Image
  //     if (featureImageRef.current) {
  //       gsap.fromTo(
  //         featureImageRef.current,
  //         { scale: 0.9, opacity: 0 },
  //         {
  //           scale: 1,
  //           opacity: 1,
  //           duration: 1,
  //           ease: 'power2.out',
  //           scrollTrigger: {
  //             trigger: sectionRef.current,
  //             start: 'top 80%',
  //             end: 'top 50%',
  //             scrub: 0.5,
  //             markers: false,
  //           },
  //         }
  //       );
  //     }

  //     // Animate Feature Items with staggered slide-in
  //     const featureItems = featureItemsRef.current.filter(Boolean);
  //     featureItems.forEach((item, index) => {
  //       gsap.fromTo(
  //         item,
  //         { x: index % 2 === 0 ? 150 : -150, opacity: 0, scale: 0.95 },
  //         {
  //           x: 0,
  //           opacity: 1,
  //           scale: 1,
  //           duration: 0.7,
  //           ease: 'power3.out',
  //           scrollTrigger: {
  //             trigger: item,
  //             start: 'top 90%',
  //             end: 'top 70%',
  //             scrub: 0.5,
  //             markers: false,
  //           },
  //         }
  //       );
  //     });
  //   }, sectionRef); // Scope context to sectionRef

  //   // Cleanup animations on component unmount
  //   return () => ctx.revert();
  // }, []);

  return (
    <section className={styles.featuresSection} ref={sectionRef}>
      <div className={styles.leftContent} ref={leftContentRef}>
        <h3 className={styles.title}>
          {/* <span className={styles.circleIcon}></span> */} Features
        </h3>
        <p className={styles.subtitle}>
          Powerful, flexible, and easy to use—addressing high costs, slow responses, and inconsistent service.
        </p>
        <div className={styles.imageContainer}>
          <img
            src={sideImg}
            alt="AI Voice Feature"
            className={styles.featureImage}
            ref={featureImageRef}
          />
        </div>
      </div>

      <div className={styles.rightContent}>
        <div
          className={styles.featureItem1}
          ref={(el) => (featureItemsRef.current[0] = el)}
        >
          <span className={styles.featureNumber}>01.</span>
          <h3>AI-Powered Call Handling</h3>
          <p>Smart AI that answers, routes, and responds—flawlessly.</p>
        </div>
        <div
          className={styles.featureItem2}
          ref={(el) => (featureItemsRef.current[1] = el)}
        >
          <span className={styles.featureNumber}>02.</span>
          <h3>24/7 Virtual Receptionist</h3>
          <p>Reliable, responsive, and always available—without the cost.</p>
        </div>
        <div
          className={styles.featureItem3}
          ref={(el) => (featureItemsRef.current[2] = el)}
        >
          <span className={styles.featureNumber}>03.</span>
          <h3>Real-Time Call Summaries</h3>
          <p>Call summaries done for you, in seconds—your memory's new best friend.</p>
        </div>
        <div className={styles.bottomRow}>
          <div
            className={styles.featureItem4}
            ref={(el) => (featureItemsRef.current[3] = el)}
          >
            <span className={styles.featureNumber}>04.</span>
            <h3>Appointment Scheduling</h3>
            <p>Set it, forget it. We'll handle the reminders too.</p>
          </div>
          <div
            className={styles.featureItem5}
            ref={(el) => (featureItemsRef.current[4] = el)}
          >
            <span className={styles.featureNumber}>05.</span>
            <h3>Custom Voice & Tone</h3>
            <p>Your brand, your tone, your way—friendly, formal, or anything in between.</p>
          </div>
        </div>
      </div>
    </section>
  );
}